export const checksums = {
  "content": "v3.5.0--oULqmIgRwKUr1aGdjvAbscdUF-JXvU_aUYgpLWyQd8Y"
}
export const checksumsStructure = {
  "content": "RFd4PSQs7AnwGKE5_gVESb4g1oHeWXyL3DUj6bVKvB8"
}

export const tables = {
  "content": "_content_content",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authorImage": "string",
      "authorName": "string",
      "body": "json",
      "category": "string",
      "cover": "string",
      "coverAlt": "string",
      "date": "string",
      "dateLabel": "string",
      "description": "string",
      "draft": "boolean",
      "excerpt": "string",
      "extension": "string",
      "keywords": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "readTime": "string",
      "relatedPosts": "json",
      "seo": "json",
      "seoTitle": "string",
      "sitemap": "json",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}